export default "__VITE_ASSET__I7oYzB65__"